import React, { Component } from 'react';
import Project from './Project';
import projectsDemos from '../projects_templates/index';
import { checkIfWebPSupported, preloadVideoPlayer } from '../utils/common';

class Projects extends Component {
	componentDidMount() {
		checkIfWebPSupported();
		preloadVideoPlayer();
	}

	render() {
		return (
			<React.Fragment>
				<section className='section projects is-medium is-white has-text-centered'>
					<div className='container is-narrow'>
						<h1
							className='title is-spaced is-size-3-desktop is-size-4-mobile'
							id='recent_projects'
						>
							My Recent Projects
						</h1>
						<h2 className='subtitle is-size-5-desktop'>
							Here are a few of my recent front-end and back-end projects. Want to
							see more? <br /> Email me:{' '}
							<a href='mailto:slavanik.dev@gmail.com'> slavanik.dev@gmail.com</a>
						</h2>
						<div className='project-grid'>
							<div className='columns is-multiline is-mobile'>
								{projectsDemos.length &&
									projectsDemos.map((project, index) => {
										return (
											<Project
												key={index}
												projectName={project.projectName}
												title={project.title}
												thumb={project.thumb}
											/>
										);
									})}
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		);
	}
}

export default Projects;
